/**
 * ConversationSkeleton — shimmer placeholders shown while a filter or search
 * fetch is in flight, so switching tabs never flashes the previous tab's rows.
 */
import { Skeleton, SkeletonGroup, skeletonKeys } from '../../components/ui/Skeleton';
import './messages.css';

interface ConversationSkeletonProps {
  rows?: number;
}

export function ConversationSkeleton({ rows = 6 }: ConversationSkeletonProps) {
  return (
    <SkeletonGroup className="messages-list">
      {skeletonKeys(rows).map(key => (
        <div className="conversation-skeleton" key={key} aria-hidden>
          <Skeleton shape="circle" className="conversation-skeleton__avatar" />
          <span className="conversation-skeleton__body">
            <Skeleton className="conversation-skeleton__line--title" />
            <Skeleton className="conversation-skeleton__line--preview" />
          </span>
        </div>
      ))}
    </SkeletonGroup>
  );
}
